import React, {Component} from 'react'
import AuthenticationService from './AuthenticationService'
import {Config} from '../../Config'
import NavigationServices from '../Common/NavigationServices'

class Logout extends Component {
  constructor() {
    super()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.navigation = new NavigationServices()
  }
  componentWillMount() {
    let url = this.navigation.getLoginUrl();
    this.authService.clear();
    if(this.props.location.state != null){
      console.log("Redirect URL: ", this.props.location.state.referrer);  
      url = url + "&st=reactredirect&redir=" + this.props.location.state.referrer;
    }
    window.location.href = url;
    // let isLoggedIn = this.authService.isLoggedIn()
    // //let url = this.authService.isAdmin() ? '/admin' : '/'
    // //console.log('After logout: ', url)
    // if (isLoggedIn) {
    //   if (this.authService.isAdmin() || window.location.pathname.indexOf('/admin') > -1) {
    //     this.authService.clear()
    //     window.location.href = Config.adminColdFusionUrl + '?pg=Login'
    //   } else {
    //     this.authService.clear()
    //     //  this.props.history.push(Config.coldFusionUrl)
    //     window.location.href = Config.coldFusionUrl + '?pg=Login'
    //   }
    // } else {
    //   // console.log(document.referrer)
    //   // console.log(window.history.back())
    //   // window.history.back()
    //   if (window.location.pathname.indexOf('/admin') > -1) {
    //     window.location.href = Config.adminColdFusionUrl + '?pg=Login'
    //   } else {
    //     window.location.href = Config.coldFusionUrl + '?pg=Login'
    //   }
    //   //}
    // }
    // //window.location.href = url
  }
  render() {
    return ( <div/> )
  }
}
export default Logout


// WEBPACK FOOTER //
// ./src/components/Security/Logout.js